export default "__VITE_ASSET__DZiSD8vS__"